var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrashedGreaterThanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F2F4F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8115_28760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.35 9.75L14.3503 10.75L13.35 9.75M14.4725 10.5C14.4907 10.3358 14.5 10.169 14.5 10C14.5 7.51472 12.4853 5.5 10 5.5C7.51472 5.5 5.5 7.51472 5.5 10C5.5 12.4853 7.51472 14.5 10 14.5C11.4136 14.5 12.675 13.8482 13.5 12.8287M10 7.5V10L11.5 11",
    stroke: "#B42318",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8115_28760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrashedGreaterThanIcon);
export default __webpack_public_path__ + "static/media/crashed-greater-than-icon.dcde5206d3af0204acc0dd652cf38ada.svg";
export { ForwardRef as ReactComponent };